import { useEffect, useState } from "react";
import { _createProcess, _CustomProcessType, _PaymentHeader } from "../../../../../core/services/dataBean/EntityCatalogVdos"
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { CustomProcessTypeSeleect } from "../../CustomProcessType/CustomProcessTypeSeleect";
import { SelectTypeProcees } from "../../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _BudgetAccountantOperation, _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { BudgetAccountantOperationSelect } from "../BudgetAccountantOperationSelect";
import { setOptions } from "react-chartjs-2/dist/utils";
import { Paymentitems } from "../Itemspago";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { toast } from "react-toastify";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { JsonFormaterInput } from "../../../../theme/Component/JsonFormaterInput";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";

export const PaymentProcess = () => {


    const _documentFactory = useDataBean(_DocumentFactory);
    const _budgetAccountantOperation = useDataBean(_BudgetAccountantOperation);
    const [idOperation, setIDOperation] = useState<number>(undefined);
    const _customProcessType = useDataBean(_CustomProcessType);
    const _paymentHeader = useDataBean(_PaymentHeader);
    const _createCprocees = useDataBean(_createProcess);
    const [idPro, setIDPro] = useState<number>(0);
    const [existente, setExistente] = useState<boolean>(false);
    const [processType, setProcessType] = useState<any>(null);
    const [customProcces, setCustomProcces] = useState<any>(null);
    const [date, setDate] = useState<any>(_single.getCurrenDate());
    const [process, setProcess] = useState<any>({});
    const [doc, setDoc] = useState<any>({});
    const [bean, setBean] = useState<any>({});
    const [responseJson, setResponseJson] = useState<any>({});
    const [responseJsonservicio, setResponseJsonservicio] = useState<any>({});
    const [getpaymentheader, setGetpaymentheader] = useState<any>({});
    const [listaprocesoresponse, setListaprocesoresponse] = useState<any>([]);
    const [documentos, setDocumentos] = useState<any>([]);
    const [properties, setProperties] = useState<any>([]);
    const [modalejecutarproceso, setModalejecutarproceso] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallistapaymentheader, setModallistapaymentheader] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [itempago, setItempago] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const modalJson = useModal("JSON", MODAL_md);
    const modalDocumento = useModal("Documento", MODAL_XL);
    const modalDelete = useModal("Eliminar item", MODAL_SM);


    useEffect(() => {
        if (process.IDProcess) {
            getPaymentHeaderCatalog();
        }
    }, [process])
    useEffect(() => {
        if (idOperation) {
            getPaymentHeaderProperties();
        }
    }, [idOperation])


    const CrearProcess = () => {

        _createCprocees.instance.createProcess(customProcces, date, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);
                    setProcess(resp);
                }
            }
        )

    }
    const getProcess = () => {

        _paymentHeader.instance.getProcess(idPro).then(
            (resp: any) => {
                if (resp) {

                    setProcess(resp);
                }
            }
        )

    }

    const getPaymentHeaderCatalog = () => {
        _paymentHeader.instance.getPaymentHeaderCatalog(process.IDProcess).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setListaprocesoresponse(resp)

                }
            }
        )
    }
    const saveProperties = () => {
        console.log(process.IDProcess, getpaymentheader)


    }
    const getPaymentHeaderProperties = () => {
        // console.log(documentfactory)
        _paymentHeader.instance.getPaymentHeaderProperties(idOperation).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    let temp = { ...properties };
                    if (resp) {
                        let keys = Object.keys(resp);
                        keys.forEach(key => {
                            temp[key] = resp[key];
                        });
                        setProperties(temp);
                    }
                }
            }
        )

    }
    const getPaymentHeaderJson = () => {
        console.log(bean.IDPaymentHeader);
        if (bean.IDPaymentHeader > 0)
            _budgetAccountantOperation.instance.getPaymentHeaderJson(bean.IDPaymentHeader).then(
                (resp: any) => {
                    if (resp) {
                        setResponseJson(resp);
                        modalJson.open();
                    }
                }
            )

    }

    const createPaymentHeader = () => {

        _paymentHeader.instance.createPaymentHeader(process.IDProcess, properties).then(
            (resp: any) => {
                if (resp) {
                    getPaymentHeaderCatalog();
                    setModallistapaymentheader({ ...modallistapaymentheader, "view": false });
                    setProperties({});
                }
            }
        )

    }
    const updatePaymentHeader = () => {

        _paymentHeader.updateCustonBean(properties).then(
            (resp: any) => {
                if (resp) {
                    getPaymentHeaderCatalog();
                    setProperties({});
                }
            }
        )
        setModallistapaymentheader({ ...modallistapaymentheader, "view": false });

    }
    const deletePaymentHeader = () => {

        _paymentHeader.deleteItemVoid(bean.IDPaymentHeader).then(
            (resp: any) => {
                if (resp) {
                    getPaymentHeaderCatalog();
                }
            }
        )
        modalDelete.close();

    }
    const getDocument = (idConsecutive: number, mnemonic: string, since: any) => {

        if (idConsecutive != null)
            _documentFactory.instance.getPdfAccountantDocument(idConsecutive, mnemonic, since, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp.DocumentURL);
                    if (resp.DocumentURL) {
                        setDoc(
                            {
                                IDDocument:idConsecutive,
                                Since:since
                            }
                        )
                        setDocumentos(resp.DocumentURL);
                        modalDocumento.open();
                    } else {
                        toast.warning("No se encontraron documentos");
                    }
                }
            )
        else {
            toast.warning("No se encontraron documentos");
        }
    }
    const exportSupplierPaymentOrder = (IDSupplierPaymentOrder: number, SupplierPaymentOrderDate: string) => {

        if (IDSupplierPaymentOrder != null)
            _documentFactory.instance.exportSupplierPaymentOrder(IDSupplierPaymentOrder, SupplierPaymentOrderDate).then(
                (resp: any) => {
                    
                    if (resp.length > 0) {
                        
                        setDocumentos(resp);
                        modalDocumento.open();
                    } else {
                        toast.warning("No se encontraron documentos");
                    }
                }
            )
        else {
            toast.warning("No se encontraron documentos");
        }
    }
    const editarPaymentHeader = () => {
        setIDOperation(bean.IDBudgetAccountantOperation);
        setProperties(bean);
        setModallistapaymentheader({ ...modallistapaymentheader, "view": true, "name": "Editar Proceso de Pagos" });

    }

    const iconButtonsItemPaymentHeader = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { setProperties({}); setModallistapaymentheader({ ...modallistapaymentheader, "view": true, "name": "Crear Proceso de Pagos" }); } }
    ]
    const listaPaymenHeader = () => {
        const botones = [
            { titulo: 'Items del Pago', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setItempago({ ...itempago, "view": true, "name": "Items del Pago" }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: editarPaymentHeader },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalDelete.open() } },
            // { titulo: 'Ejecutar Proceso', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalejecutarproceso({ ...modalejecutarproceso, "view": true, "name": "Ejecutar Proceso" }) } },
            { titulo: 'Ver Solicitud Json', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: getPaymentHeaderJson },
            {
                titulo: 'Mostrar CDP', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.CDPIDDocument, bean.CDPMnemonic, bean.CDPDate) }
            },
            {
                titulo: 'Mostrar RP', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.RPIDDocument, bean.RPMnemonic, bean.RPDate) }
            },
            {
                titulo: 'Mostrar OB', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.OBIDDocument, bean.OBMnemonic, bean.OBDate) }
            },
            {
                titulo: 'Mostrar Contabilización', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { getDocument(bean.FCIDDocument, bean.FCMnemonic, bean.FCDate) }
            },
            {
                titulo: 'Mostrar Orden de Pago', icono: 'ri-edit-2-line', visible: _single.canEdit(),
                evento: () => { exportSupplierPaymentOrder(bean.IDSupplierPaymentOrder, bean.SupplierPaymentOrderDate) }
            },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const headproceso = [
        { title: 'ID', property: 'IDPaymentHeader', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo de Operación', property: 'OperationType', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true },
        { title: 'Nombres', property: 'Names', visible: true },
        { title: 'Apellidos', property: 'Surnames', visible: true },
        { title: 'Código de Banco', property: 'BankingCode', visible: true },
        { title: 'Tipo de Cuenta', property: 'AccountType', visible: true },
        { title: 'Número de Cuenta', property: 'AccountNumber', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeCode', visible: true },
        { title: 'Referencia de Pago', property: 'OrderNumber', visible: true },
        { title: 'Fecha de Pago', property: 'AccountantDate', visible: true },


    ]

    const getBudgetAccountantOperationJsonRequest = () => {

        console.log(process.IDProcess, process.ProcessDate)

        _budgetAccountantOperation.instance.getBudgetAccountantOperationJsonRequest(process.IDProcess, process.ProcessDate).then(
            (resp) => {
                if (resp) {
                    console.log("Respuesta obtenida:", resp);
                    setResponseJson(resp);
                    modalJson.open();
                }
            }
        ).catch((error) => {
            console.error("Error al obtener la respuesta:", error);
            toast.error("Ocurrió un error al obtener la respuesta.");
        });
    };
    const getBudgetAccountantOperationJsonResponse = () => {


        // Llamada al servicio con los valores extraídos.
        _budgetAccountantOperation.instance.getBudgetAccountantOperationJsonResponse(process.IDProcess, process.ProcessDate).then(
            (resp) => {
                if (resp) {
                    console.log("Respuesta obtenida:", resp);
                    setResponseJson(resp); // Guardar la respuesta en el estado.  
                    modalJson.open();
                }
            }
        ).catch((error) => {
            console.error("Error al obtener la respuesta:", error);
            toast.error("Ocurrió un error al obtener la respuesta.");
        });
    };


    const executeBudgetAccountantOperation = () => {

        _paymentHeader.instance.executeBudgetAccountantOperation(process.IDProcess, process.ProcessDate).then(
            (resp: any) => {
                console.log(resp);
                setResponseJson(resp); // Guardar la respuesta en el estado.  
                modalJson.open();
                // toast.success('Ejecutado Exitosamente');
                // setModalejecutarproceso({ ...modalejecutarproceso, "view": false, "name": "Ejecutar Proceso" });

            }
        )

    }


    return (
        <div className="row">
            <div className="col">
                {!process.IDProcess ?
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <BasicSwitch estado={existente} eventChange={setExistente} label="Usar existente" />
                            </div>
                            {existente ?
                                <>
                                    <div className="col-md-6">
                                        <label>IDProcess</label>
                                        <input type="number" className="form-control" value={idPro} onChange={(e) => { setIDPro(parseInt(e.target.value)) }} />
                                    </div>
                                    <div className="col-md-6 mt-4">
                                        <BasicButton icon="" eventClick={getProcess}>Buscar Proceso</BasicButton>
                                    </div>
                                </>
                                :
                                <>
                                    <div className="col-md-4">
                                        <SelectTypeProcees label="Tipo de Proceso" idSelector={processType} onChange={(e) => setProcessType(e)} />
                                    </div>
                                    <div className="col-md-4">
                                        <CustomProcessTypeSeleect processType={processType} idSelector={customProcces} onChange={(e) => setCustomProcces(e)} />
                                    </div>
                                    <div className="col-md-4">
                                        <InputDate label='Fecha de Registro Contable' name='accountantDate' value={date} setDate={(e: any) => { setDate(e) }} />
                                    </div>
                                    <div className="col-md-4 mt-4">
                                        <BasicButton icon="" eventClick={CrearProcess}>Crear Proceso</BasicButton>
                                    </div>

                                </>
                            }
                        </div>
                    </>
                    :
                    <>
                        <div className="row">
                            <div className="col-md-6">
                                <p>
                                    <strong>IDProcess</strong> {process.IDProcess} <br />
                                    <strong>Nombre</strong> {process.Name} <br />
                                    <strong>Mnemonic</strong> {process.Mnemonic} <br />
                                    <strong>AccountantDate</strong> {process.AccountantDate} <br />
                                    <strong>Since</strong> {process.Since} <br />
                                </p>
                            </div>
                            <div className="col-md-2">
                                <BasicButton icon="" eventClick={getBudgetAccountantOperationJsonRequest}>Ver Json de Solicitud</BasicButton>


                            </div>
                            <div className="col-md-2">
                                <BasicButton icon="" eventClick={getBudgetAccountantOperationJsonResponse}>Ver Json de Respuesta</BasicButton>
                            </div>
                            <div className="col-md-2">
                                <BasicButton icon="" eventClick={executeBudgetAccountantOperation}>Ejecutar servicio</BasicButton>
                            </div>

                            <div className="col-md-12">
                                <BasicTable key={listaprocesoresponse} iconButtons={iconButtonsItemPaymentHeader}
                                    body={listaprocesoresponse} listButtons={listaPaymenHeader()} head={headproceso} rowSet={setBean} />
                            </div>

                        </div>
                    </>
                }


            </div>
            <div className="col-md-12">
                <Modal modal={modallistapaymentheader} updateModal={setModallistapaymentheader} eventModal={properties.IDPaymentHeader ? updatePaymentHeader : createPaymentHeader} onSubmitLabel="Guardar">

                    <div className="row">
                        <div className="col-md-12">
                            <BudgetAccountantOperationSelect idSelector={idOperation} onChange={(e) => setIDOperation(e)} />
                        </div>
                        <div className="col-md-12">

                            <div className="row">
                                {Object.keys(properties).map((row) => {
                                    return (
                                        <div className="col-md-6">
                                            <label>{row}</label>
                                            <input type="text" className="form-control" value={properties[row]}
                                                onChange={(e) => { setProperties({ ...properties, [row]: e.target.value }) }} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal modal={itempago} updateModal={setItempago}>
                    <>
                        {/* Asegúrate de extraer correctamente el IDPaymentHeader */}
                        <Paymentitems paymentHeader={bean} />
                        {/* <PrintJson json={listaprocesoresponse} /> */}
                    </>
                </Modal>
                <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                    <>
                        <div className="col-md-12 mt-4">
                            <DocumentViewer list={documentos} IDDocument={doc.IDDocument} Since={doc.Since} />
                        </div>
                    </>
                </Modal>
                <Modal modal={modalJson.modal} updateModal={modalJson.setModal}>
                    <>
                        <JsonFormaterInput rows={20} inputType="string" value={responseJson} onChange={() => { }} returnType="object" _label="Respuesta" />
                    </>
                </Modal>
                <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deletePaymentHeader}>
                    Eliminar Item
                </ModalConfirm>
            </div>

        </div >
    )
}